export const GET_PERMISSION = "permission/GET_PERMISSION";
export const GET_PERMISSION_SUCCESS = "permission/GET_PERMISSION_SUCCESS";
export const GET_PERMISSION_ERROR = "permission/GET_PERMISSION_ERROR";
